export const REQUEST_FEATURE_FLAGS = "REQUEST_FEATURE_FLAGS";
export const SERVICE_REQUEST_FETCH_USER_PROFILE =
    "SERVICE_REQUEST_FETCH_USER_PROFILE/LOAD";

export const STORE_LOAD_RECORDS = "STORE_LOAD_RECORDS";
export const STORE_CREATE_RECORD = "STORE_CREATE_RECORD";
export const STORE_UPDATE_RECORD = "STORE_UPDATE_RECORD";
export const SELF_SERVICE_STORE_BREADCRUMB = "SELF_SERVICE_STORE_BREADCRUMB";
export const SELF_SERVICE_STORE_ABLE_BREADCRUMB = "SELF_SERVICE_STORE_ABLE_BREADCRUMB";
export const UPDATE_CONFIG_DETAILS = "UPDATE_CONFIG_DETAILS";
export type CONNECTOR_TYPES = "CONNECTOR_TYPES";
export const CONNECTOR_TYPES: CONNECTOR_TYPES= "CONNECTOR_TYPES";


export type GET_ACTIVE_SERVICES = "GET_ACTIVE_SERVICES";
export const GET_ACTIVE_SERVICES: GET_ACTIVE_SERVICES = "GET_ACTIVE_SERVICES";

export type ORDER_LOAD_SUMMARY = "SELF_SERVICE_STORE/ORDER_LOAD_SUMMARY";
export const ORDER_LOAD_SUMMARY: ORDER_LOAD_SUMMARY =
    "SELF_SERVICE_STORE/ORDER_LOAD_SUMMARY";

export type SELF_SERVICE_STORE_EMPTY_CART = "SELF_SERVICE_STORE/EMPTY_CART";
export const SELF_SERVICE_STORE_EMPTY_CART: SELF_SERVICE_STORE_EMPTY_CART =
    "SELF_SERVICE_STORE/EMPTY_CART";


export type SELF_SERVICE_STORE_CALCULATE_CART_SUMMARY_PRICE = "SELF_SERVICE_STORE/CALCULATE_CART_PRICE ";
export const SELF_SERVICE_STORE_CALCULATE_CART_SUMMARY_PRICE: SELF_SERVICE_STORE_CALCULATE_CART_SUMMARY_PRICE =
    "SELF_SERVICE_STORE/CALCULATE_CART_PRICE ";

export type GET_CABLE_TYPE = "GET_CABLE_TYPE";
export const GET_CABLE_TYPE: GET_CABLE_TYPE = "GET_CABLE_TYPE";

export type GET_SERVICE_IDS = "GET_SERVICE_IDS";
export const GET_SERVICE_IDS:GET_SERVICE_IDS = "GET_SERVICE_IDS";


export type GET_CART_ITEMS = "GET_CART_ITEMS";
export const GET_CART_ITEMS:  GET_CART_ITEMS=
    "GET_CART_ITEMS";

export type FILE_UPLOAD = 'FILE_UPLOAD';
export const FILE_UPLOAD: FILE_UPLOAD = 'FILE_UPLOAD';
export type GET_BILLING_ACCOUNT_DETAILS = "GET_BILLING_ACCOUNT_DETAILS";
export const GET_BILLING_ACCOUNT_DETAILS: GET_BILLING_ACCOUNT_DETAILS=
"GET_BILLING_ACCOUNT_DETAILS";

export type ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART: ADD_TO_CART = 'ADD_TO_CART';

export type SUBMIT_ORDER = 'SUBMIT_ORDER';
export const SUBMIT_ORDER: SUBMIT_ORDER = 'SUBMIT_ORDER';

export type GET_CABLES_PRICE = "GET_CABLES_PRICE";
export const GET_CABLES_PRICE: GET_CABLES_PRICE ="GET_CABLES_PRICE";

export type GET_CURRENCY_EXCHANGE ="GET_CURRENCY_EXCHANGE";
export const GET_CURRENCY_EXCHANGE: GET_CURRENCY_EXCHANGE ="GET_CURRENCY_EXCHANGE";

export type GET_COMPLETE_CURRENCY_EXCHANGE ="GET_COMPLETE_CURRENCY_EXCHANGE";
export const GET_COMPLETE_CURRENCY_EXCHANGE: GET_COMPLETE_CURRENCY_EXCHANGE ="GET_COMPLETE_CURRENCY_EXCHANGE";

